<template>
  <div class="platform-value">
    <app-header></app-header>

    <!-- 轮播图 -->
    <!-- 轮播外层 -->
    <div class="swiper-box">
      <!-- 轮播外层 -->
      <swiper ref="mySwiper" :options="swiperOptions">
        <!-- 轮播项 -->
        <swiper-slide v-for="(slide, index) in carouselSlides" :key="index">
          <img :src="slide.bgImage" alt="" />
          <div class="slide-content">
            <div class="container">
              <div class="slide-text-content">
                <p class="slide-en-title">{{ slide.enTitle }}</p>
                <h1 class="slide-title">{{ slide.title }}</h1>
              </div>
            </div>
          </div>
        </swiper-slide>

        <!-- 小圆点 -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <!-- 对医药企业 -->
    <section class="section section-pharma">
      <div class="container">
        <h2 class="section-title">对医药企业</h2>
        <div class="value-grid grid-5">
          <div class="value-card">
            <img class="icon" src="@/assets/platform/icon01.png" />
            <h3>渠道清晰可控，杜绝串货乱价</h3>
          </div>
          <div class="value-card">
            <div class="card-icon">
              <div class="icon-circle">
                <img class="icon" src="@/assets/platform/icon02.png" />
              </div>
            </div>
            <h3>终端数据真实、全面、实时可查</h3>
          </div>
          <div class="value-card">
            <div class="card-icon">
              <div class="icon-circle">
                <img class="icon" src="@/assets/platform/icon03.png" />
              </div>
            </div>
            <h3>团队管理标准化、考核自动化</h3>
          </div>
          <div class="value-card">
            <div class="card-icon">
              <div class="icon-circle">
                <img class="icon" src="@/assets/platform/icon04.png" />
              </div>
            </div>
            <h3>营销资源精准投放，提升投入产出比</h3>
          </div>
          <div class="value-card">
            <div class="card-icon">
              <div class="icon-circle">
                <img class="icon" src="@/assets/platform/icon05.png" />
              </div>
            </div>
            <h3>构建长期稳定、合规健康的销售网络</h3>
          </div>
        </div>
      </div>
    </section>

    <!-- 对团队长与业务员 -->
    <section class="section section-team">
      <div class="container">
        <h2 class="section-title">对团队长与业务员</h2>
        <div class="value-grid grid-4 teamAndPerson">
          <div class="value-card">
            <img class="icon" src="@/assets/platform/icon06.png" />
            <h3>身份明确、绑定关系永久可溯</h3>
          </div>
          <div class="value-card">
            <img class="icon" src="@/assets/platform/icon07.png" />
            <h3>考核目标清晰，收益透明可算</h3>
          </div>
          <div class="value-card">
            <img class="icon" src="@/assets/platform/icon08.png" />
            <h3>拓展有方向、工作有工具、成长有路径</h3>
          </div>
          <div class="value-card">
            <img class="icon" src="@/assets/platform/icon09.png" />
            <h3>实现长期、稳定、可持续的市场收益</h3>
          </div>
        </div>
      </div>
    </section>

    <!-- 对药店/诊所/民营医院 -->
    <section class="section section-pharmacy">
      <div class="container">
        <h2 class="section-title">对药店/诊所/民营医院</h2>
        <div class="value-grid grid-4 teamAndPerson">
          <div class="value-card">
            <img class="icon" src="@/assets/platform/icon10.png" />
            <h3>合作正规、货源可溯、政策透明</h3>
          </div>
          <div class="value-card">
            <img class="icon" src="@/assets/platform/icon11.png" />
            <h3>服务更精准、支持更到位</h3>
          </div>
          <div class="value-card">
            <img class="icon" src="@/assets/platform/icon12.png" />
            <h3>享受专属业务员一对一服务</h3>
          </div>
          <div class="value-card">
            <img class="icon" src="@/assets/platform/icon13.png" />
            <h3>提升经营效率与产品动销能力</h3>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部标语 -->
    <section class="section section-slogan">
      <div class="container">
        <h2 class="slogan-text">康道道，以数字化之力，让医药渠道更有价值</h2>
      </div>
    </section>

    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
  name: 'PlatformValue',
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      swiperOptions: {
        // 👇 最常用配置（直接用）
        loop: true, // 无限循环
        // autoplay: false,
        autoplay: {
          delay: 3000, // 3秒切换一次
          disableOnInteraction: false, // 滑动后不停止自动轮播
          pauseOnMouseEnter: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true, // 小圆点可点击
        },
        speed: 600, // 切换速度
        slidesPerView: 1, // 一屏显示几张
        spaceBetween: 0, // 图片间距
        effect: 'slide',
      },
      currentSlide: 0,
      carouselSlides: [
        {
          bgImage: require('@/assets/platform/banner01.png'),
          enTitle: 'KANGDAO DAO PLATFORM VALUE',
          title: '重构医药广阔市场新秩序',
        },
        {
          bgImage: require('@/assets/platform/banner01.png'),
          enTitle: 'DIGITAL TRANSFORMATION',
          title: '数字化赋能医药渠道管理',
        },
        {
          bgImage: require('@/assets/platform/banner01.png'),
          enTitle: 'SMART MARKETING',
          title: '构建智慧营销新生态',
        },
      ],
      autoPlayTimer: null,
      isPaused: false,
    }
  },
  computed: {
    trackStyle() {
      return {
        transform: `translateX(-${this.currentSlide * 100}%)`,
      }
    },
  },
  mounted() {
    this.startAutoPlay()
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  methods: {
    nextSlide() {
      if (this.currentSlide < this.carouselSlides.length - 1) {
        this.currentSlide++
      } else {
        // 轮播到底后，继续从右边向左边切换
        this.currentSlide = 0
      }
    },
    goToSlide(index) {
      this.currentSlide = index
      this.resetAutoPlay()
    },
    startAutoPlay() {
      this.autoPlayTimer = setInterval(() => {
        if (!this.isPaused) {
          this.nextSlide()
        }
      }, 3000)
    },
    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer)
        this.autoPlayTimer = null
      }
    },
    pauseAutoPlay() {
      this.isPaused = true
    },
    resumeAutoPlay() {
      this.isPaused = false
    },
    resetAutoPlay() {
      this.stopAutoPlay()
      this.startAutoPlay()
    },
  },
}
</script>

<style lang="scss" scoped>
.platform-value {
  padding-top: 80px;
}

/* 轮播图样式 */
.swiper-box {
  width: 100%;
  height: 800px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.slide-content {
  position: absolute;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.swiper-container) {
  height: 100%;
}
:deep(.swiper-pagination-bullet) {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ffffff;
  margin: 0 18px !important;
  opacity: 1 !important;
  &.swiper-pagination-bullet-active {
    border-radius: 5px 5px 5px 5px;
    width: 56px;
  }
}
.slide-text-content {
  text-align: center;
  color: #fff;
}

.slide-en-title {
  font-size: 24px;
  color: #fff;
  margin-bottom: 20px;
  letter-spacing: 2px;
  opacity: 0.9;
  text-transform: uppercase;
}

.slide-title {
  font-size: 64px;
  color: #fff;
  font-weight: bold;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

/* 通用板块样式 */
.section {
  padding: 100px 0;
}

.section-title {
  height: 53px;
  line-height: 53px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-style: normal;
  font-size: 40px;
  letter-spacing: 0;
  leading-trim: NONE;
  text-align: center;
}

/* 对医药企业 */
.section-pharma {
  background: linear-gradient(180deg, #f0f9f8 0%, #ffffff 100%);
  padding: 131px 0 54px;
  .section-title {
    margin: 0;
    margin-bottom: 59px;
  }
  .value-card {
    width: 378px;
    height: 240px;
    box-sizing: border-box;
    padding: 50px 0;
    box-shadow: 0px 4px 10px 0px #1ca19633;
    img {
      width: 96px;
      height: auto;
      margin: auto;
    }
    h3 {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-style: normal;
      font-size: 20px;
      line-height: 26px;
      height: 26px;
      letter-spacing: 0;
      color: #000000;
      leading-trim: NONE;
    }
  }
}

/* 对团队长与业务员 */
.section-team {
  background-color: #f5f5f5;
  padding: 68px 0 72px;
  .section-title {
    margin: 0;
    margin-bottom: 62px;
  }
}

/* 对药店/诊所/民营医院 */
.section-pharmacy {
  background-color: #ffffff;
  padding: 68px 0 72px;
  .section-title {
    margin: 0;
    margin-bottom: 62px;
  }
  .teamAndPerson {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: 1000px;
    margin: auto;
    .value-card {
      width: 378px;
      height: 240px;
      box-sizing: border-box;
      box-shadow: 0px 4px 10px 0px #1ca19633;
      padding: 50px 0;
      .icon {
        width: 84px;
        height: 80px;
      }
      h3 {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-style: normal;
        font-size: 20px;
        line-height: 26px;
        letter-spacing: 0;
        color: #000000;
        leading-trim: NONE;
      }
    }
  }
}

/* 底部标语 */
.section-slogan {
  background: #ffffff;
  padding: 64px 0 113px;
}

.slogan-text {
  text-align: center;
  color: #000000;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-style: normal;
  font-size: 34px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0;
}

/* 卡片网格布局 */
.value-grid {
  display: grid;
  gap: 30px;
  justify-content: center;
}

.grid-5 {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.grid-5 .value-card:nth-last-child(-n + 2) {
  grid-column: auto;
}

.grid-5 .value-card:last-child {
  grid-column: 2;
}

.grid-4 {
  grid-template-columns: repeat(4, 1fr);
  max-width: 1400px;
  margin: 0 auto;
}

/* 卡片样式 */
.value-card {
  background: #fff;
  padding: 50px 30px;
  border-radius: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  text-align: center;
  transition: all 0.3s;
}

.value-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 30px rgba(32, 184, 167, 0.2);
}

.card-icon {
  margin-bottom: 25px;
}

.icon-circle {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  background: linear-gradient(135deg, #20b8a7 0%, #26d0ba 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(32, 184, 167, 0.3);
}

.icon {
  font-size: 36px;
}

.value-card h3 {
  font-size: 16px;
  color: #333;
  line-height: 1.6;
  font-weight: 500;
}

.teamAndPerson {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 1000px;
  margin: auto;
  .value-card {
    width: 378px;
    height: 240px;
    box-sizing: border-box;
    box-shadow: 0px 4px 10px 0px #1ca19633;
    padding: 50px 0;
    .icon {
      width: 84px;
      height: 80px;
    }
    h3 {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-style: normal;
      font-size: 20px;
      line-height: 26px;
      letter-spacing: 0;
      color: #000000;
      leading-trim: NONE;
    }
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .grid-5,
  .grid-4 {
    grid-template-columns: repeat(2, 1fr);
  }

  .grid-5 .value-card:last-child {
    grid-column: auto;
  }
}

@media (max-width: 768px) {
  .grid-5,
  .grid-4 {
    grid-template-columns: 1fr;
  }

  .slide-title {
    font-size: 36px;
  }

  .slide-en-title {
    font-size: 18px;
  }

  .section-title {
    font-size: 28px;
  }

  .slogan-text {
    font-size: 24px;
  }
}
</style>
